"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickFreeModuleToggleSchema = void 0;
const baseSchema_1 = require("../baseSchema");
const baseClickSchema_1 = require("../baseSchema/baseClickSchema");
class ClickFreeModuleToggleSchema extends baseClickSchema_1.BaseClickSchema {
    constructor({ freeSignUp }) {
        super({ componentName: 'FreeModuleToggle' });
        this.freeSignUp = freeSignUp;
        this.action = baseSchema_1.ActionsName.CLICK_FREE_MODULE_TOGGLE;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            freeSignUp: this.freeSignUp,
            action: this.action
        };
    }
}
exports.ClickFreeModuleToggleSchema = ClickFreeModuleToggleSchema;
